const MAXIMUM_FRACTION_VALUE = 2;

function getFractionValue(value: number | string | null): number {
    const numberValue = Number(value);

    if (!numberValue || isNaN(numberValue)) {
        return 0;
    }

    const stringValue = String(Math.floor(numberValue * 100));

    return Math.abs(MAXIMUM_FRACTION_VALUE - (stringValue.length - 1));
}

export default getFractionValue;
